<template>
    <div>
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="2000" :value="true" :color="snaclr">
            <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
        </v-snackbar>

        <div class="ml-14 mr-14 mt-5">
            <v-card elevation="0" class=" pa-1">
                <v-toolbar dense class="elevation-0  ">
                    <v-toolbar-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold title">Holdings
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div class="mt-4" v-if="histtab == 0">
                        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeText"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dates" range @input="closeMenu"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-text-field dense v-model="tabledata" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-btn @click="unpledgeregdown()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-btn :loading="tableload" @click="lumsunresdata()" icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                    <div class="mt-4" v-if="histtab == 1">
                        <v-menu v-model="menutb1" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb1"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb1" range @input="closeMenutb1"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 1">
                        <v-text-field dense v-model="tabledataall" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 1">
                        <v-btn @click="unpledgeregdownall()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 1">
                        <v-btn :loading="tableloadall" @click="allordersdata()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>


                    <div class="mt-4" v-if="histtab == 3">
                        <v-menu v-model="menutb3" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb3"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb3" range @input="redustadate"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 3">
                        <v-text-field dense v-model="redmsatse" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 3">
                        <v-btn v-if="redumstadata.filepath != ''" @click="downloadFilesat()"
                            icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 3">
                        <v-btn :loading="tableloadall" @click="redmenstatment()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                    <div class="mt-4" v-if="histtab == 7">
                        <v-menu v-model="menutb1" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb1"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb1" range @input="closeMenutb1"></v-date-picker>
                        </v-menu>
                    </div>


                    <div class="ml-3" v-if="histtab == 7">
                        <v-btn @click="unpledgeregdownall()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 7">
                        <v-btn :loading="tableloadall" @click="allordersdata()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                </v-toolbar>
                <v-divider></v-divider>
                <!-- <v-tabs v-model="histtab" color="black">

                    <v-tab class="text-capitalize">Daily Orders</v-tab>

                    <v-tab class="text-capitalize">All Orders</v-tab>
                    <v-tab class="text-capitalize">Mandate Details</v-tab>
                    <v-tab class="text-capitalize">Redemption Request</v-tab>
                    <v-tab class="text-capitalize">MF - Order </v-tab>
                    <v-tab class="text-capitalize"> SIP </v-tab>
                    <v-tab class="text-capitalize"> Holdings </v-tab>
                    

                    <v-tab class="text-capitalize" v-if="siporbookrest == 'sipbook'"> SIP OrderBook </v-tab>




                </v-tabs> -->
                
                <v-divider></v-divider>
                <v-card outlined elevation="0" class="pa-4">
                            <div class="d-flex align-center mb-4"
                                style="position: sticky; top: 0; background: white; z-index: 1;">
                                <div> <v-text-field prepend-inner-icon="mdi-account-multiple-outline"
                                        oninput="this.value = this.value.toUpperCase()" :readonly="hlodvallist"
                                        hide-details class="mt-5 ml-5 rounded-pill" background-color="#F1F3F8" flat solo
                                        v-model="holdindcid" style="width: 380px;" dense label="Client Id"
                                        type="text"></v-text-field>
                                </div>
                                <v-btn @click="getclientholdlist()" :disabled="holdindcid.length < 2 || hlodvallist"
                                    :loading="holdingload" rounded elevation="0" class="text-none mt-5 ml-5 mr-5"
                                    color="primary">
                                    Check
                                </v-btn>

                                <v-btn @click="clearholdindata()" :disabled="holdindcid.length == ''" rounded outlined
                                    elevation="0" class="text-none mt-5" color="black">
                                    Clear
                                </v-btn>
                            </div>

                            <!-- <v-row>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Invested Value </p>
                                        <p class="mb-0 title font-weight-bold "> ₹ {{
                                            holdstadata.purchase_value ?
                                                holdstadata.purchase_value : "00.00" }} </p>

                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Current Value </p>
                                        <p class="mb-0 title font-weight-bold "> ₹ {{
                                            holdstadata.current_value ?
                                                holdstadata.current_value : "00.00" }} </p>

                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Abs Returns % </p>
                                        <p class="mb-0 title font-weight-bold"
                                            :style="{ color: (parseFloat(holdstadata.percentage) >= 0) ? 'green' : 'red' }">
                                            {{ holdstadata.gain_or_loss ? holdstadata.gain_or_loss : "00.00" }}
                                            ({{ holdstadata.percentage ? holdstadata.percentage : "00.00%" }})
                                        </p>


                                    </v-card>
                                </v-col>
                            </v-row> -->

                            <v-data-table mobile-breakpoint :search="sipsearchlist" height="50vh" fixed-header
                                :items-per-page="100" style="border: 1px solid #F1F3F8;" :headers="holdingheader"
                                :items="cliholdlist" class="elevation-0 mt-5" disable-sort outlined>

                                <template v-slot:[`item.returnper`]="{ item }">
                                    <p class="mb-0"
                                        :style="{ color: (parseFloat(item.gain_or_loss) >= 0) ? 'green' : 'red' }">
                                        {{ item.gain_or_loss ? parseFloat(item.gain_or_loss).toFixed(4) : '0.00' }}
                                        ( {{ item.percentage ? parseFloat(item.percentage).toFixed(2) : '0.00' }} %)
                                    </p>

                                </template>

                                <template v-slot:[`item.purchase`]="{ item }">
                                    <p class="mb-0">{{ item.purchase ? parseFloat(item.purchase).toFixed(4) : '0.00' }}
                                    </p>
                                </template>

                                <template v-slot:[`item.current`]="{ item }">
                                    <p class="mb-0">{{ item.current ? parseFloat(item.current).toFixed(2) : '0.00' }}
                                    </p>
                                </template>


                                <template v-slot:[`item.buy_price`]="{ item }">
                                    <p class="mb-0">{{ item.buy_price ? parseFloat(item.buy_price).toFixed(4) : '0.00'
                                    }}</p>
                                </template>
<!-- 
                                <template v-slot:[`item.order`]="{ item }">
                                    <v-btn small outlined rounded elevation="0" class="black--text text-none" @click="ordercheckfun(item)"
                                        dense>Additional</v-btn>
                                </template> -->

                                <template v-slot:[`item.redmenbtn`]="{ item }">
                                    <v-btn outlined rounded elevation="0" class="black--text text-none"
                                        @click="redemcheck(item)" dense>Redemption</v-btn>
                                </template>

                            </v-data-table>

                            <v-dialog v-model="redeamdia" width="400px">
                                <v-card elevation="0" class="pa-5 rounded-ld">
                                    <div class="d-flex">
                                        <P class="font-weight-bold subtitle-1 maintext--text mb-1">Redemption</P>
                                        <div class="ml-auto">
                                            <v-btn icon @click="redeamdia = false"> <v-icon>mdi-close</v-icon></v-btn>
                                        </div>
                                    </div>

                                    <div>
                                        <p class="font-weight-regular subtitle-1 fs-14 subtext--text mb-2">
                                            Redemption units
                                            <span class="float-right caption">Total units : <b>{{ redmetiondata.avg_qty ?
                                                redmetiondata.avg_qty :
                                                "00.00" }}</b></span>
                                        </p>
                                        <v-text-field height="40px" background-color="#F1F3F8" flat class="rounded-pill"
                                            solo type="number" hide-details hide-spin-buttons v-model="mf_redqty"
                                         
                                            :min="redmetiondata.MINIMUM_REDEMPTION_QTY" :max="redmetiondata.avg_qty">
                                            <!-- <template #append>
                            <v-card v-if="redmetiondata.NET - mf_redqty > 0" @click="mf_redqty = redmetiondata.NET" class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                              +
                              {{ menudata.item ? (menudata.item.NET - mf_redqty).toFixed(3) : 0 }}
                            </v-card>
                          </template> -->
                                            <!--   <template #prepend-inner>
                          <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none">
                              <path
                                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                fill="white" />
                              <path
                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                fill="#999999" />
                            </svg>
                          </div>
                        </template> -->
                                        </v-text-field>
                                        <p class="caption subtext--text ml-6 mt-1">Min. redemption uints {{
                                            redmetiondata.Minimum_Redemption_Qty ? redmetiondata.Minimum_Redemption_Qty
                                                : 0 }}</p>

                                        <div class="d-flex">
                                            <div>
                                                <p class="font-weight-semibold caption mb-2"></p>
                                                <!-- <p class="font-weight-bold mb-0">{{ mf_redqty * redmetiondata.nav }}</p> -->

                                            </div>
                                            <div class="ml-auto">
                                                <v-btn :loading="redapicallload" outlined rounded elevation="0"
                                                    style="background-color: black;" class="mt-3 white--text text-none"
                                                    @click="redamtionapi()" dense>Redemption</v-btn>
                                            </div>
                                        </div>
                                        <!-- 
                        <p class="font-weight-regular fs-14 subtext--text mb-2">Redemption amount</p>
                        <v-text-field
                          height="40px"
                          background-color="outline"
                          flat
                          class="rounded-pill"
                          solo
                          type="number"
                          hide-details
                          hide-spin-buttons
                          readonly
                          v-model="mf_invest_amt"
                          @keyup="mf_invest_amt ? (mf_invest_amt = Number(mf_invest_amt)) : mf_invest_amt, (mf_redqty = mf_invest_amt / menudata.item.NET_ASSET_VALUE)"
                          min="1"
                          :max="menudata.item.current"
                        >
                       

                          <template #prepend-inner>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z" fill="white" />
                              <path
                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                fill="#999999"
                              />
                            </svg>
                          </template>
                        </v-text-field> -->
                                        <!-- <p class="fs-10 subtext--text ml-6 mt-1">Max. redemption amount {{ menudata.item.NET_ASSET_VALUE ? menudata.item.NET_ASSET_VALUE : 0 }}</p> -->
                                    </div>
                                </v-card>

                            </v-dialog>

                              <v-dialog v-model="additionaldia" persistent width="600px">
            <v-card elevation="0" outlined>
                <div class="px-7 py-7" style="background-color: #F1F3F8;">
                    <p class="mb-0 font-weight-bold">{{ redmetiondata && redmetiondata.SCHEME_NAME ?
                        redmetiondata.SCHEME_NAME :
                        "" }}</p>
                </div>
                <div class="pa-3">
                    <p class="font-weight-regular fs-14 subtext--text mt-3 mb-2">Investment amount</p>
                    <v-text-field height="40px" background-color="#F1F3F8" flat class="rounded-pill" solo type="number"
                        hide-details hide-spin-buttons v-model="mf_invest_amt"
                        :min="redmetiondata.Minimum_Purchase_Amount || 0"
                        :step="redmetiondata.Minimum_Purchase_Amount || 1000">
                        <template #append>
                            <v-card v-if="redmetiondata.Minimum_Purchase_Amount" style="background-color: #F1F3F8;"
                                @click="mf_invest_amt = Number(mf_invest_amt || 0) + Number(redmetiondata.Minimum_Purchase_Amount)"
                                class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                +{{ redmetiondata.Minimum_Purchase_Amount }}
                            </v-card>
                        </template>
                        <template #prepend-inner>
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                    fill="white" />
                                <path
                                    d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                    fill="#999999" />
                            </svg>
                        </template>
                    </v-text-field>
                    <p v-if="redmetiondata && redmetiondata.Minimum_Purchase_Amount"
                        class="fs-10 subtext--text ml-6 mt-1">
                        Min. ₹{{ redmetiondata.Minimum_Purchase_Amount }} (multiple of {{
                            redmetiondata.Minimum_Purchase_Amount }})
                    </p>

                    <span class="font-weight-regular caption subtext--text d-none d-md-block">
                        <!-- AUM <span class="primary--text caption font-weight-bold"></span>
                                    {{ SelectedItem.AUM ? (SelectedItem.AUM / 10000000).toFixed(2) : '0.00' }}Cr. -->
                        <br />
                        NAV <span class="primary--text font-weight-bold">
                            ₹{{ redmetiondata.NET_ASSET_VALUE || '0.00' }}
                        </span>
                    </span>
                    <v-row class="mt-7">
                        <v-col cols="6">
                            <v-btn rounded outlined color="black" elevation="0" class="text-none"
                                @click="additionaldia = false" block>Close</v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn rounded color="black" :loading="sumbitload" elevation="0"
                                class="text-none white--text" @click="sendorder()" block>One-Time</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>

        </v-dialog>


                        </v-card>
                <v-tabs-items v-model="histtab">
                    <v-tab-item>

                        <!-- {{ typeof dispayadmindat }} -->


                        <v-card v-if="paymentlinkcard" outlined elevation="0" class="pa-5 mt-4"
                            style="width: 80%; border: 1px solid #E0E0E0;">
                            <div class="d-flex">
                                <p class=" title font-weight-bold">Re-generate Payment Link</p>
                                <div class="ml-auto">
                                    <v-btn @click="urlcopfun()" icon><v-icon>mdi-content-copy</v-icon></v-btn>
                                </div>
                            </div>

                            <template>
                                <v-simple-table style=" border: 1px solid #E0E0E0;">
                                    <template v-slot:default>

                                        <tbody outlined style=" border: 1px solid #E0E0E0;">
                                            <tr>


                                                <td>{{ reinipaylink && reinipaylink.clientcode ? reinipaylink.clientcode
                                                    : 0
                                                    }}</td>
                                                <td> <a :href="`${paymentres && paymentres.url ? paymentres.url : 0}`"
                                                        target="_blank"><b>{{ paymentres && paymentres.url ?
                                                            paymentres.url : 0 }}</b></a></td>

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </template>
                        </v-card>

                    </v-tab-item>

                    <v-tab-item>
                        <v-data-table fixed-header :items-per-page="100" height="75vh" :search="tabledataall"
                            :loading="tableloadall" :headers="headersall" :items="alloredrdata" class="elevation-0 mt-1"
                            disable-sort outlined>



                            <template v-slot:[`item.buysell`]="{ item }">
                                <p class="mb-0">{{ item.buysell == "P" ? "Purchase" : "Redemption " }}</p>
                            </template>
                            <template v-slot:[`item.ordertype`]="{ item }">
                                <p class="mb-0">{{ item.ordertype == "NRM" ? "One-Time" : item.ordertype == "XSP" ?
                                    "SIP" :
                                    item.ordertype }}</p>
                            </template>
                            <template v-slot:[`item.ordernumber`]="{ item }">
                                <!-- {{ item.sipregnno }} {{  item.order_number}} -->
                                <p class="mb-0">{{ (item.sipregnno == "" || item.sipregnno == "0") ? item.ordernumber :
                                    item.sipregnno }}</p>
                            </template>

                            <template v-slot:[`item.amount`]="{ item }">
                                <p class="mb-0">{{ item.buysell == "R" ? item.units + ' Units' : item.amount }}</p>
                            </template>

                            <template v-slot:[`item.orderstatus`]="{ item }">
                                <v-tooltip bottom color="black">

                                    <template v-slot:activator="{ on, attrs }">
                                        <p v-bind="attrs" v-on="on">{{ item.orderstatus }}</p>
                                    </template>

                                    <span class="mb-0" style="display: block; width: 300px; white-space: normal;">
                                        {{ item.orderremarks }}
                                    </span>
                                </v-tooltip>
                            </template>


                        </v-data-table>
                    </v-tab-item>

                    <v-tab-item>

                    </v-tab-item>


                    <v-tab-item>
                        <v-data-table fixed-header height="75vh" :loading="redemload" :items-per-page="100"
                            :search="redmsatse" :headers="headersred" :items="redumstadata.resp_data"
                            class="elevation-0 mt-1" disable-sort outlined>

                            <template v-slot:[`item.OrderType`]="{ item }">
                                <p class="mb-0">{{ item.OrderType == "NRM" ? "One-Time" : ite.OrderType }}</p>
                            </template>

                            <!-- 
                            <template v-slot:[`item.ordertype`]="{ item }">
                                <p class="mb-0">{{ item.ordertype == "NRM" ? "One-Time" : item.ordertype == "XSP" ?
                                    "SIP" :
                                    item.ordertype }}</p>
                            </template>
                            <template v-slot:[`item.order_number`]="{ item }">
                                <p class="mb-0">{{ item.order_number == "" ? item.xsip_regid :
                                    item.order_number }}</p>
                            </template>

                            <template v-slot:[`item.orderstatus`]="{ item }">
                                <v-tooltip style="width: 300px;" bottom color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <p v-bind="attrs" v-on="on">{{ item.orderstatus }}</p>
                                    </template>
                                    <span>{{ item.orderremarks }}</span>
                                </v-tooltip>
                            </template> -->

                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                        <div class="sec-footer">
                            <MffoterOder />
                        </div>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card outlined elevation="0" class="pa-4">
                            <!-- Fixed Section -->
                            <div class="d-flex align-center mb-4"
                                style="position: sticky; top: 0; background: white; z-index: 1;">
                                <div> <v-text-field prepend-inner-icon="mdi-account-multiple-outline"
                                        oninput="this.value = this.value.toUpperCase()" :readonly="sipvalread"
                                        hide-details class="mt-5 ml-5 rounded-pill" background-color="#F1F3F8" flat solo
                                        v-model="sipclient" style="width: 380px;" dense label="Client Id"
                                        type="text"></v-text-field>
                                </div>
                                <v-btn @click="sipchekfun()" :disabled="sipclient.length < 2 || sipvalread"
                                    :loading="sipcliload" rounded elevation="0" class="text-none mt-5 ml-5 mr-5"
                                    color="primary">
                                    Check
                                </v-btn>

                                <v-btn @click="clearsipdata()" :disabled="sipclient.length == ''" rounded outlined
                                    elevation="0" class="text-none mt-5" color="black">
                                    Clear
                                </v-btn>
                            </div>

                            <v-data-table mobile-breakpoint :search="sipsearchlist" height="50vh" fixed-header
                                :items-per-page="100" style="border: 1px solid #F1F3F8;" :headers="headersiplist"
                                :items="sipdataclilist" class="elevation-0 mt-5" disable-sort outlined>

                                <template v-slot:[`item.startdate`]="{ item }">
                                    <p class="mb-0">{{ item.startdate.split(' ')[0] }}</p>

                                </template>

                                <template v-slot:[`item.enddate`]="{ item }">
                                    <p class="mb-0">{{ item.enddate.split(' ')[0] }}</p>

                                </template>

                                <template v-slot:[`item.current`]="{ item }">
                                    <p class="mb-0">{{ item.current ? parseFloat(item.current).toFixed(2) : '0.00' }}
                                    </p>
                                </template>


                            </v-data-table>


                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card outlined elevation="0" class="pa-4">
                            <div class="d-flex align-center mb-4"
                                style="position: sticky; top: 0; background: white; z-index: 1;">
                                <div> <v-text-field prepend-inner-icon="mdi-account-multiple-outline"
                                        oninput="this.value = this.value.toUpperCase()" :readonly="hlodvallist"
                                        hide-details class="mt-5 ml-5 rounded-pill" background-color="#F1F3F8" flat solo
                                        v-model="holdindcid" style="width: 380px;" dense label="Client Id"
                                        type="text"></v-text-field>
                                </div>
                                <v-btn @click="getclientholdlist()" :disabled="holdindcid.length < 2 || hlodvallist"
                                    :loading="holdingload" rounded elevation="0" class="text-none mt-5 ml-5 mr-5"
                                    color="primary">
                                    Check
                                </v-btn>

                                <v-btn @click="clearholdindata()" :disabled="holdindcid.length == ''" rounded outlined
                                    elevation="0" class="text-none mt-5" color="black">
                                    Clear
                                </v-btn>
                            </div>

                            <v-row>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Invested Value </p>
                                        <p class="mb-0 title font-weight-bold "> ₹ {{
                                            holdstadata.purchase_value ?
                                                holdstadata.purchase_value : "00.00" }} </p>

                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Current Value </p>
                                        <p class="mb-0 title font-weight-bold "> ₹ {{
                                            holdstadata.current_value ?
                                                holdstadata.current_value : "00.00" }} </p>

                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card class="pa-4 rounded-lg text-center" elevation="0" outlined>
                                        <p class="mb-2 subtitle-2 font-weight-semibold "> Abs Returns % </p>
                                        <p class="mb-0 title font-weight-bold"
                                            :style="{ color: (parseFloat(holdstadata.percentage) >= 0) ? 'green' : 'red' }">
                                            {{ holdstadata.gain_or_loss ? holdstadata.gain_or_loss : "00.00" }}
                                            ({{ holdstadata.percentage ? holdstadata.percentage : "00.00%" }})
                                        </p>


                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-data-table mobile-breakpoint :search="sipsearchlist" height="50vh" fixed-header
                                :items-per-page="100" style="border: 1px solid #F1F3F8;" :headers="holdingheader"
                                :items="cliholdlist" class="elevation-0 mt-5" disable-sort outlined>

                                <template v-slot:[`item.returnper`]="{ item }">
                                    <p class="mb-0"
                                        :style="{ color: (parseFloat(item.gain_or_loss) >= 0) ? 'green' : 'red' }">
                                        {{ item.gain_or_loss ? parseFloat(item.gain_or_loss).toFixed(4) : '0.00' }}
                                        ( {{ item.percentage ? parseFloat(item.percentage).toFixed(2) : '0.00' }} %)
                                    </p>

                                </template>

                                <template v-slot:[`item.purchase`]="{ item }">
                                    <p class="mb-0">{{ item.purchase ? parseFloat(item.purchase).toFixed(4) : '0.00' }}
                                    </p>
                                </template>

                                <template v-slot:[`item.current`]="{ item }">
                                    <p class="mb-0">{{ item.current ? parseFloat(item.current).toFixed(2) : '0.00' }}
                                    </p>
                                </template>


                                <template v-slot:[`item.buy_price`]="{ item }">
                                    <p class="mb-0">{{ item.buy_price ? parseFloat(item.buy_price).toFixed(4) : '0.00'
                                    }}</p>
                                </template>

                                <template v-slot:[`item.redmenbtn`]="{ item }">
                                    <v-btn outlined rounded elevation="0" class="black--text text-none"
                                        @click="redemcheck(item)" dense>Redemption</v-btn>
                                </template>

                            </v-data-table>

                            <v-dialog v-model="redeamdia" width="400px">
                                <v-card elevation="0" class="pa-5 rounded-ld">
                                    <div class="d-flex">
                                        <P class="font-weight-bold subtitle-1 maintext--text mb-1">Redemption</P>
                                        <div class="ml-auto">
                                            <v-btn icon @click="redeamdia = false"> <v-icon>mdi-close</v-icon></v-btn>
                                        </div>
                                    </div>

                                    <div>
                                        <p class="font-weight-regular subtitle-1 fs-14 subtext--text mb-2">
                                            Redemption units
                                            <span class="float-right caption">Total units : <b>{{ redmetiondata.avg_qty ?
                                                redmetiondata.avg_qty :
                                                "00.00" }}</b></span>
                                        </p>
                                        <v-text-field height="40px" background-color="#F1F3F8" flat class="rounded-pill"
                                            solo type="number" hide-details hide-spin-buttons v-model="mf_redqty"
                                           
                                            :min="redmetiondata.Minimum_Redemption_Qty" :max="redmetiondata.avg_qty">
                                            <!-- <template #append>
                            <v-card v-if="redmetiondata.NET - mf_redqty > 0" @click="mf_redqty = redmetiondata.NET" class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                              +
                              {{ menudata.item ? (menudata.item.NET - mf_redqty).toFixed(3) : 0 }}
                            </v-card>
                          </template> -->
                                            <!--   <template #prepend-inner>
                          <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none">
                              <path
                                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                fill="white" />
                              <path
                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                fill="#999999" />
                            </svg>
                          </div>
                        </template> -->
                                        </v-text-field>
                                        <p class="caption subtext--text ml-6 mt-1">Min. redemption uints {{
                                            redmetiondata.Minimum_Redemption_Qty ? redmetiondata.Minimum_Redemption_Qty
                                                : 0 }}</p>

                                        <div class="d-flex">
                                            <div>
                                                <p class="font-weight-semibold caption mb-2"> </p>
                                                <p class="font-weight-bold mb-0"></p>

                                            </div>
                                            <div class="ml-auto">
                                                <v-btn :loading="redapicallload" outlined rounded elevation="0"
                                                    style="background-color: black;" class="mt-3 white--text text-none"
                                                    @click="redamtionapi()" dense>Redemption</v-btn>
                                            </div>
                                        </div>
                                        <!-- 
                        <p class="font-weight-regular fs-14 subtext--text mb-2">Redemption amount</p>
                        <v-text-field
                          height="40px"
                          background-color="outline"
                          flat
                          class="rounded-pill"
                          solo
                          type="number"
                          hide-details
                          hide-spin-buttons
                          readonly
                          v-model="mf_invest_amt"
                          @keyup="mf_invest_amt ? (mf_invest_amt = Number(mf_invest_amt)) : mf_invest_amt, (mf_redqty = mf_invest_amt / menudata.item.NET_ASSET_VALUE)"
                          min="1"
                          :max="menudata.item.current"
                        >
                       

                          <template #prepend-inner>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z" fill="white" />
                              <path
                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                fill="#999999"
                              />
                            </svg>
                          </template>
                        </v-text-field> -->
                                        <!-- <p class="fs-10 subtext--text ml-6 mt-1">Max. redemption amount {{ menudata.item.NET_ASSET_VALUE ? menudata.item.NET_ASSET_VALUE : 0 }}</p> -->
                                    </div>
                                </v-card>

                            </v-dialog>

                        </v-card>
                    </v-tab-item>

                    <!-- <v-tab-item>
                        <v-card outlined elevation="0" class="pa-4">

                            <div class="align-center mb-4"
                                style="position: sticky; top: 0; background: white; z-index: 1;">
                                <div>
                                    <p>Paste the Cookie Here</p>

                                    <v-textarea name="input-4-1" label="" outlined v-model="holdindcid"
                                        style="width: 580px;" dense></v-textarea>


                                </div>
                                <v-btn @click="cokkegetapi()" :disabled="holdindcid.length < 40" :loading="cokkieload"
                                    rounded elevation="0" class="text-none px-14 ml-5 mr-5" color="primary">
                                    Submit
                                </v-btn>


                            </div>


                        </v-card>
                    </v-tab-item> -->

                    <v-tab-item>
                        <v-card outlined elevation="0" class="pa-4">
                            <div class="d-flex">
                                <p class="title font-weight-bold">Sip OrderBook</p>
                                <div class="ml-auto">
                                    <div class="ml-3" v-if="histtab == 8">
                                        <v-text-field dense v-model="tabledataall" hide-details
                                            prepend-inner-icon="mdi-magnify" style="max-width: 180px"></v-text-field>
                                    </div>
                                </div>
                            </div>
                            <v-data-table fixed-header :items-per-page="100" height="50vh" :search="tabledataall"
                                :loading="tableloadall" :headers="headersallred" :items="sipnewArray"
                                class="elevation-0 mt-1" disable-sort outlined>



                                <template v-slot:[`item.buysell`]="{ item }">
                                    <p class="mb-0">{{ item.buysell == "P" ? "Purchase" : "Redemption " }}</p>
                                </template>
                                <template v-slot:[`item.ordertype`]="{ item }">
                                    <p class="mb-0">{{ item.ordertype == "NRM" ? "One-Time" : item.ordertype == "XSP" ?
                                        "SIP" :
                                        item.ordertype }}</p>
                                </template>
                                <template v-slot:[`item.order_number`]="{ item }">
                                    <p class="mb-0">{{ item.order_number == "" ? item.xsip_regid :
                                        item.order_number }}</p>
                                </template>
                                <template v-slot:[`item.amount`]="{ item }">
                                    <p class="mb-0">{{ item.buysell == "R" ? item.units + ' Units' : item.amount }}</p>
                                </template>

                                <template v-slot:[`item.orderstatus`]="{ item }">
                                    <v-tooltip bottom color="black">

                                        <template v-slot:activator="{ on, attrs }">
                                            <p v-bind="attrs" v-on="on">{{ item.orderstatus }}</p>
                                        </template>

                                        <span class="mb-0" style="display: block; width: 300px; white-space: normal;">
                                            {{ item.orderremarks }}
                                        </span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:[`item.cancelord`]="{ item }">
                                    <v-btn :loading="cancelstload" class="text-none" @click="oderdeletedet(item)" dense
                                        elevation="0" outlined v-if="item.orderstatus === 'VALID'">Cancel Order</v-btn>
                                </template>


                            </v-data-table>
                            <div class="d-flex">
                                <p class="title font-weight-bold">Redemption OrderBook</p>
                                <div class="ml-auto">
                                    <div class="ml-3" v-if="histtab == 8">
                                        <v-text-field dense v-model="tabledataallred" hide-details
                                            prepend-inner-icon="mdi-magnify" style="max-width: 180px"></v-text-field>
                                    </div>
                                </div>
                            </div>

                            <v-data-table fixed-header :items-per-page="100" height="50vh" :search="tabledataallred"
                                :loading="tableloadall" :headers="headersallred" :items="redmacationcancellist"
                                class="elevation-0 mt-1" disable-sort outlined>



                                <template v-slot:[`item.buysell`]="{ item }">
                                    <p class="mb-0">{{ item.buysell == "P" ? "Purchase" : "Redemption " }}</p>
                                </template>
                                <template v-slot:[`item.ordertype`]="{ item }">
                                    <p class="mb-0">{{ item.ordertype == "NRM" ? "One-Time" : item.ordertype == "XSP" ?
                                        "SIP" :
                                        item.ordertype }}</p>
                                </template>
                                <template v-slot:[`item.order_number`]="{ item }">
                                    <p class="mb-0">{{ item.order_number == "" ? item.xsip_regid :
                                        item.order_number }}</p>
                                </template>
                                <template v-slot:[`item.amount`]="{ item }">
                                    <p class="mb-0">{{ item.buysell == "R" ? item.units + ' Units' : item.amount }}</p>
                                </template>

                                <template v-slot:[`item.orderstatus`]="{ item }">
                                    <v-tooltip bottom color="black">

                                        <template v-slot:activator="{ on, attrs }">
                                            <p v-bind="attrs" v-on="on">{{ item.orderstatus }}</p>
                                        </template>

                                        <span class="mb-0" style="display: block; width: 300px; white-space: normal;">
                                            {{ item.orderremarks }}
                                        </span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:[`item.cancelord`]="{ item }">
                                    <v-btn :loading="cancelstload" class="text-none" @click="cancelredfun(item)" dense
                                        elevation="0" outlined small rounded
                                        v-if="item.orderstatus === 'PENDING' && item.buysell == 'R'">Cancel
                                        Order</v-btn>
                                </template>


                            </v-data-table>


                            <v-dialog v-model="dialogcancel" persistent max-width="490">

                                <v-card class="pa-5 rounded-lg">
                                    <p class="title font-weight-bold">
                                        Are You sure you want cancel this order ?
                                    </p>
                                    <p class="subtitle-1 font-weight-semibold"> clientcode : {{ calceldiadet.clientcode
                                    }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> schemename : {{ calceldiadet.schemename
                                    }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> sipregnno : {{ calceldiadet.sipregnno }}
                                    </p>

                                    <p class="caption font-weight-bold"> Reject reson *
                                    </p>
                                    <!-- {{ cancelresonlist }} {{ cancelresfd }} -->
                                    <v-select placeholder="Reject reson" dense item-value="id" :items="cancelresonlist"
                                        item-text="reason_name" outlined v-model="cancelresfd"></v-select>
                                    <p v-if="cancelresfd == '13'" class="caption font-weight-bold"> Enter
                                        the Reason *
                                    </p>
                                    <v-text-field dense placeholeder="Enter the Reason" outlined v-model="canmanreason"
                                        v-if="cancelresfd == '13'"></v-text-field>


                                    <!-- <v-spacer></v-spacer> -->
                                    <v-row>
                                        <v-col>
                                            <v-btn block color="black mr-14 darken-1 text-none px-14" rounded outlined
                                                @click="dialogcancel = false">
                                                close
                                            </v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn block color="black darken-1 ml-10 text-none px-14"
                                                :loading="finalloadcan" @click="cancelapucall()" rounded outlined>
                                                Continue
                                            </v-btn>
                                        </v-col>
                                    </v-row>


                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="dialogredcancel" persistent max-width="400">

                                <v-card class="pa-5 rounded-lg">
                                    <p class="title font-weight-bold">
                                        Are You Sure you Want to cancel Your Order ?
                                    </p>
                                    <p class="font-weight-semibold">clientcode : {{ candiashowdata.clientcode ?
                                        candiashowdata.clientcode : "" }}</p>
                                    <p class="font-weight-semibold">schemename : {{ candiashowdata.schemename ?
                                        candiashowdata.schemename : "" }}</p>
                                    <p class="font-weight-semibold">ordernumber : {{ candiashowdata.ordernumber ?
                                        candiashowdata.ordernumber : "" }}</p>


                                    <v-row>
                                        <v-col cols="6">
                                            <v-btn block color="black " rounded outlined small
                                                @click="dialogredcancel = false">
                                                close
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn block color="black " rounded :loading="canredload" outlined small
                                                @click="redcancelapi()">
                                                Continue
                                            </v-btn>
                                        </v-col>
                                    </v-row>


                                </v-card>
                            </v-dialog>


                        </v-card>
                    </v-tab-item>

                </v-tabs-items>


                <v-dialog persistent v-model="createmat" transition="dialog-bottom-transition" max-width="600">
                    <v-card class="pb-5 overflow-hidden" color="cardbg">
                        <v-card class="elevation-0 pa-4" color="#F1F3F8">
                            <div class="d-flex">
                                <p class="font-weight-bold fs-16 maintext--text mb-0">
                                    Create mandate
                                </p>
                            </div>
                        </v-card>

                        <div class="pa-4">
                            <p class="font-weight-regular fs-14 subtext--text mb-2">Amount *</p>
                            <v-text-field :readonly="orderpoploader" height="40px" background-color="#F1F3F8" flat
                                class="rounded-pill mb-4" solo type="number" hide-details hide-spin-buttons
                                @keyup="creatManmfamt ? (creatManmfamt = Number(creatManmfamt)) : creatManmfamt >= 100 ? mf_initial_amt : 100"
                                :min="100" :step="1000" v-model="creatManmfamt">
                                <template #append>
                                    <v-card @click="creatManmfamt += 1000"
                                        class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                        +
                                        {{ 1000 }}
                                    </v-card>
                                </template>

                                <template #prepend-inner>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path
                                            d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                            fill="white" />
                                        <path
                                            d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                            fill="#999999" />
                                    </svg>
                                </template>
                            </v-text-field>

                            <v-row no-glutters class="pb-4">
                                <v-col cols="6">
                                    <p class="font-weight-regular fs-14 subtext--text mb-2">Start date *</p>

                                    <v-menu v-model="creatManmffrommenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                hide-details v-model="creatManmffrom" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker :readonly="orderpoploader"
                                            :min="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 2).toISOString().slice(0, 10)"
                                            v-model="creatManmffrommodel" no-title
                                            @input="(creatManmffrommenu = false), (creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10))"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <p class="font-weight-regular fs-14 subtext--text mb-2">End date *</p>
                                    <v-menu v-model="creatManmftomenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                hide-details v-model="creatManmfto" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker :readonly="orderpoploader"
                                            :min="creatManmffrommodel ? new Date(new Date().getFullYear(), new Date(creatManmffrommodel).getMonth() + 2, new Date().getDate()).toISOString().slice(0, 10) : new Date()"
                                            v-model="creatManmftomodel" no-title
                                            @input="creatManmftomenu = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <p class="font-weight-bold fs-14 mb-2">Remarks</p>
                            <v-text-field background-color="#F1F3F8" v-model="alertremarks" flat class="rounded-pill"
                                solo dense type="text"> </v-text-field>
                        </div>

                        <div class="mx-4">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn block @click="createmat = false" color="#F1F3F8" :disabled="orderloader"
                                        class="text-none rounded-pill elevation-0 subtext--text px-6" height="40px">
                                        Cancel </v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn @click="createmandaute()" color="black" :loading="orderloader"
                                        :disabled="orderloader" block
                                        class="text-none rounded-pill elevation-0 white--text subtext--text px-6"
                                        height="40px"> Submit
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>



                    </v-card>
                </v-dialog>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-card>
        </div>
    </div>
</template>


<script>
const today = new Date().toISOString().split("T")[0];

import exportFromJSON from "export-from-json";
// import MffoterOder from '../views/MFAdminOrder.vue'
// import { readonly } from "vue";
import axios from "axios";

export default {
    components: {
        // MffoterOder,

    },
    data() {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            dates: [today, today],
            datestb1: [today, today],
            datestb3: [today, today],

            menutb1: false,
            menutb3: false,
            modal: false,
            menu2: false,
            tabledata: "",
            headers: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },

                { text: 'order placed by', value: 'order_placed_by' },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'order_number' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'scheme_name' },
                { text: 'Buy/Sell', value: 'buysell_type' },

                { text: 'Order Type', value: 'order_type' },
                { text: 'Amount', value: 'inv_lump_amt' },

                { text: 'Status', value: 'local_status' },
                // { text: '', value: 'staaction' },

            ],
            headersnewww: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },

                { text: 'order placed by', value: 'order_placed_by' },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'order_number' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'scheme_name' },
                { text: 'Buy/Sell', value: 'buysell_type' },

                { text: 'Order Type', value: 'order_type' },
                { text: 'Amount', value: 'inv_lump_amt' },

                { text: 'Status', value: 'local_status' },
                // { text: '', value: 'staaction' },

            ],
            tabledataall: "",
            headersall: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'ordernumber' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'schemename' },
                { text: 'Buy/Sell', value: 'buysell' },

                { text: 'Order Type', value: 'ordertype' },
                { text: 'Amount', value: 'amount' },

                { text: 'Status', value: 'orderstatus' },

            ],
            headersallred: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'ordernumber' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'schemename' },
                { text: 'Buy/Sell', value: 'buysell' },

                { text: 'Order Type', value: 'ordertype' },
                { text: 'Amount', value: 'amount' },

                { text: 'Status', value: 'orderstatus' },
                { text: '', value: 'cancelord' },


            ],
            headersallmat: [
                {
                    text: 'Reg Date & Time',
                    align: 'start',
                    value: 'RegnDate',
                },
                {
                    text: 'Approved Date & Time',
                    align: 'start',
                    value: 'ApprovedDate',
                },
                { text: 'Client Id', value: 'ClientCode' },
                { text: 'Client Name', value: 'ClientName' },
                { text: 'Mandate Id', value: 'MandateId' },
                { text: 'Mandate Type', value: 'MandateType' },

                { text: 'Amount', value: 'Amount' },

                { text: 'Status', value: 'Status' },
                { text: '              ', value: 'linkman' },


            ],

            headersred: [
                {
                    text: 'Date',
                    align: 'start',
                    value: 'OrderDate',
                },
                { text: 'Client Id', value: 'ClientCode' },
                { text: 'Client Name', value: 'ClientName' },
                { text: 'Folio No', value: 'FolioNo' },
                { text: 'Order No', value: 'OrderNo' },

                { text: 'Order Type', value: 'OrderType' },
                // { text: 'Qty', value: 'Qty' },
                { text: 'Unit', value: 'Unit' },
                { text: 'Amount', value: 'Amt' },


                // { text: 'Status', value: 'Status' },
                // { text: '              ', value: 'linkman' },


            ],
            tableloadall: true,
            dispayadmindat: [],
            snackbar: false,
            snackmsgbar: "",
            snaclr: "#000",
            tableload: true,
            histtab: 8,
            alloredrdata: [],
            overlay: false,
            mf_mandates: [],
            message: '',
            mf_mandate: "",
            mdclientid: "",
            madcheckload: false,
            respondischeck: false,
            mangertresdata: [],
            urlcopyenable: false,
            mndteemtydat: "",
            createmat: false,
            creatManmfamt: 1000,
            creatManmffrommodel: "",
            creatManmffrommenu: false,

            creatManmftomodel: "",
            creatManmftomenu: false,
            creatManmRemarks: "",
            orderloader: false,
            orderpoploader: false,
            alertremarks: "",
            gemandlinkload: false,
            tablesearman: "",
            selectedmaid: "",
            redumstadata: [],
            redmsatse: "",
            redemload: true,
            sipclient: "",
            sipvalread: false,
            sipcliload: false,
            sipdataclilist: [],
            sipsearchlist: "",
            headersiplist: [
                {
                    text: 'Reg Date',
                    align: 'start',
                    value: 'regdate',
                },
                {
                    text: 'Start Date',

                    value: 'startdate',
                },
                { text: 'End date', value: 'enddate' },

                { text: 'Client Id', value: 'clientcode' },
                { text: 'Client Name', value: 'clientname' },
                { text: 'Script Name', value: 'schemename' },
                { text: 'Mandate Id', value: 'mandateid' },
                { text: 'Frequency Type', value: 'frequencytype' },

                { text: 'SIP Reg Number', value: 'sipregnumber' },
                { text: 'Amount', value: 'installmentamount' },

                // { text: 'Qty', value: 'Qty' },
                // { text: 'Unit', value: 'Unit' },
                { text: 'Status', value: 'status' },
            ],

      holdingheader:[
              
                { text: 'Client Id', value: 'ClientCode' },
                // { text: 'Client Name', value: 'CLIENT_NAME' },
                { text: 'Script Name', value: 'name' },
                { text: 'Units', value: 'avg_qty' },
                { text: 'Cur Nav', value: 'Cur_Nav' },
                { text: 'Minimum Redemption Qty', value: 'Minimum_Redemption_Qty' },
                { text: 'current value', value: 'current_value' },

                { text: 'invested value', value: 'invested_value' },

                { text: 'profit loss', value: 'profit_loss' },
                // { text: '', value: 'order' },

                // { text: '', value: 'redmenbtn' },

                { text: '', value: 'redmenbtn' },


            ],
            reinitload: false,
            paymentlinkcard: false,
            paymentres: [],
            cliholdlist: [],
            holdindcid: "",
            hlodvallist: false,
            holdingload: false,
            holdstadata: [],
            // snackmsgbar: "",
            redeamdia: false,
            redmetiondata: [],
            mf_redqty: "",
            redapicallload: false,
            sipnewArray: [],
            calceldiadet: [],
            dialogcancel: false,
            cancelresonlist: [],
            cancelresfd: "",
            cancelstload: false,
            // cancelresfd:"",
            canmanreason: "",
            finalloadcan: false,
            siporbookrest: "",
            cokkieload: false,
            // holdindcid:""
            tabledataallred: "",
            redmacationcancellist: [],
            dialogredcancel: false,
            candiashowdata: "",
            canredload: false,
            dispayadmindatnew: [],
            additionaldia: false,
            sumbitload: false,
            mf_invest_amt: "",

        }

    },
    methods: {
        cancelredfun(item) {
            this.candiashowdata = item
            this.dialogredcancel = true
        },
            ordercheckfun(item) {
            this.additionaldia = true
            this.redmetiondata = item
 this.mf_invest_amt = this.redmetiondata.Minimum_Purchase_Amount;
        },
             sendorder() {

            this.sumbitload = true
            let data = JSON.stringify({
                "client_code": this.holdindcid,
                "scheme_code": this.redmetiondata.Scheme_Code,
                "isin": this.redmetiondata.ISIN,
               "amount": String(this.mf_invest_amt),
                "placed_by": localStorage.getItem("brcode"),
                "adminemail": this.adminemail,
                "order_type":"ADDITIONAL"
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/lumsum_purchase_aprm',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            let axiosThis = this;
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.sumbitload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
        // this.getclientholdlist_new()

                        axiosThis.snackmsgbar = response.data.msg;
                        axiosThis.additionaldia = false;

                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "red";
                        axiosThis.snackmsgbar = response.data.msg;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                    axiosThis.sumbitload = false

                });

        },

        redcancelapi() {
            this.canredload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.candiashowdata.clientcode,
                "order_number": this.candiashowdata.ordernumber
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/lumsum_redemption_cancel',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.dialogredcancel = false
                    if (response.data.stat == 'Ok') {

                        axiosThis.holdindcid = ""
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data.response_message;
                        axiosThis.allordersdata()

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.canredload = false
                    axiosThis.dialogredcancel = false

                });

        },
        cokkegetapi() {
            this.cokkieload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "cookie": this.holdindcid
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'http://192.168.5.175:5000/holdings_from_inv',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.cokkieload = false

                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == 'Ok') {

                        axiosThis.holdindcid = ""
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data.msg;

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.cokkieload = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.holdindcid = ""


                });

        },
        oderdeletedet(item) {
            this.calceldiadet = item
            this.cancelreason()
        },
        cancelreason() {
            this.cancelstload = true
            const axios = require('axios');

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/reasons',
                headers: {}
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.cancelstload = false

                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == 'Ok') {

                        this.dialogcancel = true

                        axiosThis.cancelresonlist = response.data.data;

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    console.log("else ");
                    axiosThis.cancelstload = false

                });

        },

        cancelapucall() {
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.calceldiadet.clientcode,
                "xsip_reg_no": this.calceldiadet.sipregnno,
                "internal_refer_no": this.calceldiadet.internal_refer_no,
                "case_no": this.cancelresfd,
                "remarks": this.cancelresfd == '13' ? this.canmanreason : ""
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/xsip_cancel',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    axiosThis.finalloadcan = false
                    axiosThis.dialogcancel = false

                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data;
                        axiosThis.allordersdata()
                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }

                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.finalloadcan = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.dialogcancel = false


                });

        },

        redamtionapi() {
            this.finalloadcan = true
            this.redapicallload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "ClientCode": this.redmetiondata.ClientCode,
                "scheme_code": this.redmetiondata.Scheme_Code,
                "redqty": this.mf_redqty,
                          "placed_by": localStorage.getItem("brcode"),
    "source": `Branch Dasboard - ${localStorage.getItem("email")}`,
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/PlaceRedeemOrder',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    axiosThis.redeamdia = false
                    axiosThis.redapicallload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = 'Redemption Order  Initiated';

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.redeamdia = false
                    axiosThis.redapicallload = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                });

        },
        getclientholdlist() {
            this.holdingload = true
            this.cliholdlist = []
            this.holdstadata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "ClientCode": this.holdindcid
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/holdings',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.holdingload = false

                    if (response.data.stat == 'Ok') {
                        axiosThis.cliholdlist = response.data.data
                        axiosThis.hlodvallist = true
                        // console.log("ifff");
                        axiosThis.holdstadata = response.data

                    }
                 
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.holdingload = false

                });

        },
        clearholdindata() {

            this.holdindcid = ""
            this.cliholdlist = []
            this.holdstadata = []
            this.hlodvallist = false
        },
        redemcheck(item) {
            this.redeamdia = true
            this.redmetiondata = item
            this.mf_redqty = item.avg_qty
        },
        reinitiateapicall(item) {
            this.reinitload = item.order_number
            console.log(item);
            this.reinipaylink = item
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": item.clientcode,
                "order_number": item.order_number
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/order_status_checking',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        if (response.data.server_resp == "100|PAYMENT NOT INITIATED FOR GIVEN ORDER") {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "green";
                            axiosThis.snackmsgbar = "Payment Link Generated";
                            axiosThis.paymentlinkgen(item.clientcode)
                        } else {
                            axiosThis.reinitload = false
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "orange";
                            axiosThis.snackmsgbar = response.data.server_resp;
                        }
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "red";
                        axiosThis.snackmsgbar = response.data;
                        axiosThis.reinitload = false

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "red";
                    axiosThis.snackmsgbar = error;
                    axiosThis.reinitload = false

                });


        },

        paymentlinkgen(ccode) {
            this.reinitload = true
            this.paymentres = []
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": ccode
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/payment_gateway_link',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.reinitload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.paymentres = response.data
                        axiosThis.paymentlinkcard = true
                        // axiosThis.snackbar = true;
                        // axiosThis.snaclr = "green";
                        // axiosThis.snackmsgbar = response.data;
                        // window.open(`${response.data.url}`, '_blank');
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data;
                    }

                })
                // 
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "red";
                    axiosThis.snackmsgbar = error
                    axiosThis.reinitload = false

                });

        },

        sipchekfun() {

            this.sipcliload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.sipclient
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/sip_applied_clients_data',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.sipcliload = false

                    if (response.data.stat == "Ok") {
                        axiosThis.sipdataclilist = response.data.datas
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "SIP Details Listed"
                        axiosThis.snaclr = "green"
                        axiosThis.sipvalread = true


                    }
                    else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.sipcliload = false
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"

                });

        },

        clearsipdata() {
            this.sipvalread = false
            this.sipclient = ""
            this.sipdataclilist = []
        },


        redmenstatment() {
            this.redemload = true
            this.redumstadata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.datestb3[0],
                "to_date": this.datestb3[1]
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/redemption_statement',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    //   console.log(JSON.stringify(response.data));
                    axiosThis.redemload = false

                    if (response.data.stat == "Ok") {
                        axiosThis.redumstadata = response.data

                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.redemload = false

                });

        },
        downloadFilesat() {
            const fileUrl = this.redumstadata.filepath
            window.open('https://v3.mynt.in/mf' + fileUrl, '_blank');
        },

        setDefaultmandate() {
            this.creatManmffrommodel = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
            this.creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(this.creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10);
        },
        createmandaute() {
            if (this.creatManmfamt >= 100) {
                this.orderloader = true
                const axios = require('axios');
                let data = JSON.stringify({
                    "client_code": this.mdclientid,
                    "amount": String(this.creatManmfamt),
                    "startdate": this.creatManmffrom,
                    "enddate": this.creatManmfto
                });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mf/mandate_creation',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                var axiosThis = this
                axios.request(config)
                    .then((response) => {
                        // console.log(JSON.stringify(response.data));
                        axiosThis.createmat = false
                        this.orderloader = false
                        if (response.data.stat == "Ok") {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "green";
                            axiosThis.snackmsgbar = 'Mandate registration done successfully';
                            axiosThis.clientmaddet()
                        } else {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "red";
                            axiosThis.snackmsgbar = response.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        axiosThis.createmat = false
                        this.orderloader = false
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "red";
                        axiosThis.snackmsgbar = 'Network Error';
                    });
            } else {
                this.snackbar = true;
                this.snaclr = "red";
                this.snackmsgbar = 'The minimum amount required to create a mandate is ₹100.';
            }


        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        urlcopfun() {

            const url = this.mangertresdata.url;
            navigator.clipboard.writeText(url)
                .then(() => {
                    this.snackbar = true;
                    this.snaclr = "green";
                    this.snackmsgbar = "URL copied to clipboard!"
                    console.log('URL copied to clipboard!');
                    // You can also show a toast or snackbar here
                })
                .catch((err) => {
                    console.error('Failed to copy:', err);
                    this.snackbar = true;
                    this.snaclr = "red";
                    this.snackmsgbar = "Failed to copy Url"
                });


        },
        cleardata() {
            this.mdclientid = ""
            this.mf_mandates = [];
            this.mf_mandate = null;
            this.respondischeck = false
            this.mangertresdata = []
            this.mndteemtydat = ""

        },

        clientmaddet() {
            this.madcheckload = true
            this.mf_mandates = [];
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.mdclientid,
                "mandate_id": "",
                "from_date": "01/01/1900",
                "to_date": `31/12/${new Date().getFullYear()}`
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mandate_details',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    var mandate = response.data
                    axiosThis.madcheckload = false
                    axiosThis.mndteemtydat = response.data
                    if (mandate.stat == "Ok") {
                        axiosThis.respondischeck = true
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "Mandate Details Listed"
                        axiosThis.snaclr = "green"
                        axiosThis.mf_mandates = mandate.data.MandateDetails;
                        axiosThis.mf_mandate = mandate.data.MandateDetails[0];
                    } else if (mandate.error == 'Mandate Details Not Found') {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "There are no mandates available, so please create one."
                        axiosThis.snaclr = "orange"
                    }
                    else {
                        axiosThis.mf_mandates = [];
                        axiosThis.mf_mandate = null;
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = mandate.error
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.madcheckload = false

                });

        },

        mandatelinkgenfun(status, manid) {
            if (status != 'REJECTED' && status != 'APPROVED') {
                this.selectedmaid = manid
                this.gemandlinkload = manid
                this.mangertresdata = []
                const axios = require('axios');
                let data = JSON.stringify({
                    "client_code": this.mdclientid,
                    "mandate_id": manid
                });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mf/e_mandate',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                var axiosThis = this
                axios.request(config)
                    .then((response) => {
                        // console.log(JSON.stringify(response.data));
                        axiosThis.gemandlinkload = false

                        if (response.data.stat == "Ok") {
                            axiosThis.mangertresdata = response.data
                            axiosThis.snackbar = true
                            axiosThis.snackmsgbar = "Mandates  Link Generated"
                            axiosThis.snaclr = "green"
                            // axiosThis.urlcopyenable = true

                        } else {
                            axiosThis.snackbar = true
                            axiosThis.snackmsgbar = response.data.error
                            axiosThis.snaclr = "error"
                            axiosThis.gemandlinkload = false

                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = error
                        axiosThis.snaclr = "error"
                        axiosThis.gemandlinkload = false

                    });
            } else {
                this.snackbar = true
                this.snackmsgbar = `${status == 'APPROVED' ? "Your Mandate is Already Approved" : "Your Mandate is Rejected So Please Create a New Mandate"}`
                this.snaclr = "error"
            }
        },

        lumsunresdata() {
            this.tableload = true
            this.dispayadmindat = []
            this.dispayadmindatnew = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.dates[0],
                "to_date": this.dates[1],
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mf_orders_dashboards',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.tableload = false
                    // console.log(JSON.stringify(response.data));
                    // // axiosThis.dispayadmindat = response.data
                    // axiosThis.dispayadmindatnew = response.data;
                    // console.log("typeof data:", typeof axiosThis.dispayadmindatnew);

                    // let jsonData = axiosThis.dispayadmindatnew;

                    // try {
                    //     // Optional deep replace of NaN/undefined with null
                    //     const sanitized = JSON.parse(JSON.stringify(jsonData, (key, value) => {
                    //         if (typeof value === "number" && isNaN(value)) return null;
                    //         if (typeof value === "undefined") return null;
                    //         return value;
                    //     }));

                    //     console.log("Converted JSON:", sanitized);
                    //     axiosThis.dispayadmindat = sanitized;
                    // } catch (error) {
                    //     console.error("Error during sanitizing:", error);
                    // }
                    if (response.data.stat == "Ok") {
                        axiosThis.dispayadmindat = response.data.data

                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.tableload = false
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                });

        },
        closeMenu() {
            if (this.dates.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.lumsunresdata()
                this.menu = false; // Close date picker after selection
            }
        },
        closeMenutb1() {
            if (this.datestb1.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.allordersdata()
                this.menutb1 = false; // Close date picker after selection
            }
        },
        redustadate() {
            if (this.datestb3.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.redmenstatment()
                this.menutb3 = false; // Close date picker after selection
            }
        },
        unpledgeregdown() {
            let rows = [];
            for (let t = 0; t < this.dispayadmindat.length; t++) {
                const element = this.dispayadmindat[t];
                rows.push({
                    "Date & Time": element.date_time,
                    "order placed by": element.order_placed_by,
                    "Client Id": element.clientcode,
                    "Order Number": element.order_number,
                    "Order No": element.order_number,
                    "ISIN":
                        element.isin,
                    "Fund Name": element.scheme_name,
                    "Order Type": element.order_type == "NRM" ? "One-Time" : element.order_type == "XSP" ? "SIP" : element.order_type,
                    "Status": element.local_status


                });
            }
            const exportType = exportFromJSON.types.csv;

            exportFromJSON({
                data: rows,
                fileName: `mfadmin_data` + this.dates,
                exportType: exportType,
            });
        },
        unpledgeregdownall() {
            let rows = [];
            for (let t = 0; t < this.alloredrdata.length; t++) {
                const element = this.alloredrdata[t];
                rows.push({
                    "Date & Time": element.date_time,
                    "Client Id": element.clientcode,
                    "Order Number": element.ordernumber,

                    "sipregnno": element.sipregnno,
                    "ISIN":
                        element.isin,
                    "Fund Name": element.schemename,
                    "Order Type": element.ordertype == "NRM" ? "One-Time" : element.ordertype == "XSP" ? "SIP" : element.ordertype,
                    "Amount": element.amount,

                    "Status": element.local_status,
                    "orderremarks": element.orderremarks



                });
            }
            const exportType = exportFromJSON.types.csv;

            exportFromJSON({
                data: rows,
                fileName: `mfadmin_data` + this.datestb1,
                exportType: exportType,
            });
        },
        allordersdata() {
            this.sipnewArray = []
            this.redmacationcancellist = []


            this.tableloadall = true
            this.alloredrdata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.datestb1[0],
                "to_date": this.datestb1[1]
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mf_admin_orderbook',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.alloredrdata = response.data.data
                        axiosThis.tableloadall = false
                        for (let index = 0; index < axiosThis.alloredrdata.length; index++) {
                            const element = response.data.data[index];
                            if (element.ordertype === 'XSP') {
                                axiosThis.sipnewArray.push(element);
                            }
                            if (element.ordertype === 'NRM') {
                                axiosThis.redmacationcancellist.push(element);
                            }
                        }
                        console.log("axiosThis.sipnewArray", axiosThis.sipnewArray);


                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                        axiosThis.tableloadall = false

                    }
                    //   axiosThis.alloredrdata = response.data.data
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.tableloadall = false

                });

        },
        logout() {
            this.overlay = true;

            setTimeout(() => {
                localStorage.clear();

                window.location.assign("/mflogin");
                // localStorage.clear();
            }, 1000);

            // window.location.reload();
            // this.$router.push("/");
        },
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" ~ ");
        },
        dateRangeTexttb1() {
            return this.datestb1.join(" ~ ");
        },
        dateRangeTexttb3() {
            return this.datestb3.join(" ~ ");
        },
        creatManmffrom() {
            return this.formatDate(this.creatManmffrommodel);
        },

        creatManmfto() {
            return this.formatDate(this.creatManmftomodel);
        },
    },
    mounted() {
        // this.lumsunresdata()
        // this.allordersdata()
        // this.redmenstatment()
        this.first = localStorage.getItem("emailmf");
        this.siporbookrest = this.$route.query.sip

        console.log("siiii", this.siporbookrest);

        //  console.log(" this.first", this.first);

        // if (this.first == null) {
        //  this.$router.push("/mflogin");
        // }
    }
}
</script>